import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

const AffiliateList = React.lazy(() =>
  import(/* webpackChunkName: "affiliates-list" */ "./affiliate-list")
);
const AffiliatePayouts = React.lazy(() =>
  import(/* webpackChunkName: "affiliates-payouts" */ "./payouts")
);
const CommissionSettings = React.lazy(() =>
  import(/* webpackChunkName: "affiliates-settings" */ "./commission-settings")
);
const AffiliateReports = React.lazy(() =>
  import(/* webpackChunkName: "affiliates-reports" */ "./reports")
);
const FraudControl = React.lazy(() =>
  import(/* webpackChunkName: "affiliates-fraud" */ "./fraud-control")
);
const MarketingKitAdmin = React.lazy(() =>
  import(/* webpackChunkName: "affiliates-marketing-kit" */ "./marketing-kit")
);

const AffiliatesRouter = ({ match }) => (
  <Suspense fallback={<div className="loading" />}>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
      <Route
        path={`${match.url}/list`}
        render={(props) => <AffiliateList {...props} />}
      />
      <Route
        path={`${match.url}/payouts`}
        render={(props) => <AffiliatePayouts {...props} />}
      />
      <Route
        path={`${match.url}/commission`}
        render={(props) => <CommissionSettings {...props} />}
      />
      <Route
        path={`${match.url}/reports`}
        render={(props) => <AffiliateReports {...props} />}
      />
      <Route
        path={`${match.url}/fraud`}
        render={(props) => <FraudControl {...props} />}
      />
      <Route
        path={`${match.url}/marketing-kit`}
        render={(props) => <MarketingKitAdmin {...props} />}
      />
      <Redirect to="/error" />
    </Switch>
  </Suspense>
);
export default AffiliatesRouter;
